import React, { Component } from 'react'
import MultiSelectReact from 'react-multi-select-ext';

  
const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000',
};

export class ColumnDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: this.props.options,
        }
    }

    optionClicked = () => {

    }

  render() {
    return (
        <MultiSelectReact
        options={this.state.options}
        optionClicked={this.props.optionClicked}
        selectedBadgeClicked={this.props.selectedBadgeClicked}
        selectedOptionsStyles={selectedOptionsStyles}
        optionsListStyles={optionsListStyles}
        enableSelectAllNone={true}
    />
    )
  }
}

export default ColumnDropdown